<template>
    <Card>
      <LocalDataTable :init-document="is_mounted" :functions="functions" :columns="columns" ajax-link="admin/rejectOfferReason/list"></LocalDataTable>
    </Card>
</template>

<script>
import MasterLayout from "@/components/MasterLayout";
import Card from "@/components/forms/Card";
import LocalDataTable from "@/components/LocalDataTable";
import {mapActions} from "vuex";
import Swal from "sweetalert2";
import {AppApi} from "@/api/AppApi";
import {showSystemNoti} from "@/shared/helper";
let mounted = false;
export default {
  name: "rejectOfferReasonList",
  components: {LocalDataTable, Card, MasterLayout},
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
    async delFunc(id,element)
    {
      Swal.fire({
        title: 'آیا مطمئن هستید؟',
        text: "تمام اطلاعات مربوط به دلیل رد کردن پیشنهاد حذف می شود.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'تایید حذف!',
        cancelButtonText: 'کنسل',
      }).then(async (result) => {
        if (result.value) {
          const result = await AppApi.deleteRejectOfferReason(id);
          if (result.ok)
          {
            if (element)
              $(element).closest('tr').remove();
            showSystemNoti('success', result.message);
          }
          else
            showSystemNoti('danger',result.error);
        }
      })
    }
  },
  data(){
    return{
      is_mounted : mounted,
      functions:[
        {name: 'delFunc',method : this.delFunc}
      ],
      columns : [
        {title : 'عنوان'},
        {title : 'نوع کاربر'},
        {title : '<i class="far fa-cogs"></i>',sortable : false,searchable : false},
      ]
    }
  },
  async mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('دلایل رد کردن پیشنهاد');
    this.setShowHead(true);
    this.is_mounted = mounted;
    mounted = true;
  }
}
</script>

<style scoped>

</style>